// ----------------------------------------------------------------------------
// Used with React Hook Form's setValue method.
// ----------------------------------------------------------------------------
export const DIRTY = { shouldDirty: true };

export const DIRTY_VALIDATE = {
  shouldDirty: true,
  shouldValidate: true,
};

export const DIRTY_VALIDATE_TOUCH = {
  shouldDirty: true,
  shouldValidate: true,
  shouldTouch: true,
};
